import Image from "next/image";
import React from "react";

const Footer = () => {
  return (
    <div>
      <div className="mx-8 xl:mx-20 2xl:mx-48 py-24 ">
        <div className="flex flex-col sm:flex-row items-top justify-between text-center ">
          <div>
            <div className="flex items-center">
              <div className="relative overflow-y-hidden h-8 w-32 sm:w-36 mx-auto sm:ml-0">
                <Image src="/icons/logo-text.svg" alt="" layout="fill" />
              </div>
            </div>
            <p className="caption-gray font-thin text-sm sm:text-base">
              &copy; GetFuture Technologies 2022
            </p>
          </div>
          <p className="mt-2 sm:mt-0 sm:text-2xl">help@getfuture.io</p>
        </div>
        <div>
          <p className="mt-8 caption-gray  text-sm sm:text-base font-thin text-center sm:text-left">
            Disclaimer: All market data shown in the images on this page are
            used for illustrative purposes only. The contents of this site are
            not to be taken as financial advice.
          </p>
          <p className="mt-8 caption-gray  text-sm sm:text-base font-thin text-center sm:text-left">
            Risk notice: Money in your Up &amp; Down wallet is held at leverage,
            meaning your gains & losses are amplified as the price of bitcoin
            rises or falls. Crypto prices are volatile - Please take note of
            this risk while investing.
          </p>
        </div>
      </div>
      <div className="w-full footer-bg"></div>
    </div>
  );
};

export default Footer;
